import { TeamCursor } from "./TeamCursor";
import { MatchCell } from "./MatchCell";
import { Trophy } from "./Trophy";
import { GameVars } from "../../GameVars";
import { TrophyState } from "./TrophyState";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";

    export class TrophyContainer extends Phaser.Group {

        public static CELL_CLICKABLE_LIMIT_LEFT = 260;
        public static CELL_CLICKABLE_LIMIT_RIGHT = 705;
        public static CELL_CLICKABLE_LIMIT_TOP = 75; 
        public static TOP_CELL_CENTER = 384;

        // usado para posicionar el siguiente
        public containerHeight: number;
        public teamCursor: TeamCursor;
        public topPositionSlidingIndex: number;

        private unlockedMatches: number;
        private tournamentData: TournamentData;
        private lastCell_py: number;
        private cells: MatchCell[];
        private trophy: Trophy;
        private finalStep_py: number;
        private semiStep_py: number;
        private quarterStep_py: number;
        private roundOf16Step_py: number;
        private groupStageStep_py: number;
        private classificationStep_py: number;
        private stripeContainer: Phaser.Group;
        private selectTeamButton: Phaser.Button;
        private clickOnCellsActivated: boolean;

        constructor(game: Phaser.Game, tournamentData: TournamentData) {

            super(game, null, "trophy-container", false);

            this.finalStep_py = 0;
            this.semiStep_py = 0;
            this.quarterStep_py = 0;
            this.roundOf16Step_py = 0;
            this.groupStageStep_py = 0;
            this.classificationStep_py = 0;

            this.tournamentData = tournamentData;
            this.name = this.tournamentData.name;

            this.unlockedMatches = 0;

            this.addTrophy();
            this.addCells();
            this.addLabels();
            this.addClosingStripe();

            // mirar si el primer partido de todos se ha ganado
            const matchesData: MatchData[] = this.tournamentData.matchesData;
            const i = matchesData.length;

            if (!matchesData[i - 1].won && !matchesData[i - 1].locked && !this.tournamentData.teamSelected) {

                this.clickOnCellsActivated = false;
                this.addSelectTeamButton();

            } else if (!matchesData[i - 1].locked) {

                this.clickOnCellsActivated = true;

                if ((this.tournamentData.name === GameVars.justUnlockedTournamentName) || !this.tournamentData.won ) {
                    this.addCursor();
                }

                this.addClosingStripeChangeTeamButton();
            }
        }

        public onClick(x: number, y: number): void {

            if (!this.clickOnCellsActivated) {
                return;
            }

            // pasar y al sistema de coordenadas propio
            y = y - this.y;

            // mirar en cual de los rectangulos esta el punto
            for (let i = 0; i < this.cells.length; i++) {

                if ( !this.cells[i].locked && this.cells[i].boundingBox.contains(x, y)) {

                    this.cells[i].mark();
                    let matchesData: MatchData[] = this.tournamentData.matchesData;
                    TrophyState.currentInstance.onMatchSelected(this.tournamentData,  matchesData[i]);
                    break;
                }
            }
        }

        public getSlidingIndex(): number {

            let slidingIndex: number;

            if (this.tournamentData.won) {

                slidingIndex  = this.topPositionSlidingIndex;

            } else {

                let totalMatches = this.tournamentData.matchesData.length;

                if (totalMatches < 12) {
    
                    if (this.unlockedMatches < 6) {
                        slidingIndex = this.topPositionSlidingIndex + 1;
                    } else {
                        slidingIndex  = this.topPositionSlidingIndex;
                    }
    
                } else {
                   
                    if (this.unlockedMatches < 6) {
                        slidingIndex = this.topPositionSlidingIndex + 2;
                    } else if (this.unlockedMatches < 10) { 
                        slidingIndex  = this.topPositionSlidingIndex + 1;
                    } else {
                        slidingIndex  = this.topPositionSlidingIndex;
                    }
                }
            }

            return slidingIndex;
        }

        public getBottomSlidingIndex(): number {

            if (this.tournamentData.matchesData.length > 12) {
                return this.topPositionSlidingIndex + 2;
            } else {
                return this.topPositionSlidingIndex + 1;
            }
        }

        private addTrophy(): void {

            this.trophy = new Trophy(this.game, this.tournamentData.trophyImageName);
            this.trophy.x = TrophyContainer.CELL_CLICKABLE_LIMIT_LEFT + this.trophy.trophyWidth / 2;
            this.trophy.y = 115;

            if (GameVars.tournamentJustUnlocked && this.tournamentData.name === GameVars.getCurrentTournamentName() && GameVars.matchJustUnlocked ) {

                TrophyState.currentInstance.addConfetti();

                this.game.time.events.add(2000, function(): void {
                    this.trophy.animate();
                }, this);

            } else if (this.tournamentData.won) {

                this.trophy.x = TrophyContainer.TOP_CELL_CENTER;

                // la bandera del pais ganador por detras
                let playerID = GameVars.getTeamIDFromTeamName(this.tournamentData.selectedTeamName);
                let flagTextureName = "bandera_" + GameVars.formatNumberForTextureAtlas(playerID);

                const flagImage = new Phaser.Image(this.game, this.trophy.x, this.trophy.y, "texture_atlas_5", flagTextureName );
                flagImage.scale.setTo(1.75, 1.75 * GameVars.scaleY);
                flagImage.anchor.setTo(.5, 0);
                this.add(flagImage);

                // unos rayos para lograr mayor contraste
                const rays = new Phaser.Image(this.game, this.trophy.x, this.trophy.y + this.trophy.trophyHeight / 2, "texture_atlas_1", "rays");
                rays.anchor.setTo(.5);
                rays.scale.setTo(2, 1.5);
                rays.blendMode = 3;
                this.add(rays);
            }

            this.add(this.trophy);
        }

        private addCells(): void {

            this.cells = [];

            let numberGroupMatches = 0;

            // mirar si tiene 2 o 3 partidos de grupo
            for (let i = 0; i < this.tournamentData.matchesData.length; i++) {
                if (this.tournamentData.matchesData[i].matchType ===  GameConstants.GROUP_STAGE_MATCH) {
                    numberGroupMatches++;
                }
            }

            let cell_py = this.trophy.y + this.trophy.trophyHeight - 5;

            let matchCell: MatchCell;
            let stepImageName: string;
            let stepImage: Phaser.Image;
            let groupMatchesStepAdded: boolean = false;

            for (let i = 0; i < this.tournamentData.matchesData.length; i++) {

                stepImageName = null;

                // decidir que imagen se pone
                if (this.tournamentData.matchesData[i].matchType === GameConstants.FINAL_MATCH) {
                    stepImageName = "escalon_final";
                    this.finalStep_py = cell_py;
                } else if (this.tournamentData.matchesData[i].matchType ===  GameConstants.SEMIFINAL_MATCH) {
                    stepImageName = "escalon_semifinal";
                    this.semiStep_py = cell_py;
                } else if (this.tournamentData.matchesData[i].matchType ===  GameConstants.QUARTERFINAL_MATCH) {
                    stepImageName = "escalon_cuartos";
                    this.quarterStep_py = cell_py;
                } else if (this.tournamentData.matchesData[i].matchType ===  GameConstants.ROUND_OF_16_MATCH) {
                    stepImageName = "escalon_octavos";
                    this.roundOf16Step_py = cell_py;
                } else if (this.tournamentData.matchesData[i].matchType ===  GameConstants.GROUP_STAGE_MATCH && !groupMatchesStepAdded) {

                    if (numberGroupMatches === 3) {
                        stepImageName = "escalon_liguilla_3";
                    } else {
                        stepImageName = "escalon_liguilla_2";
                    }

                    groupMatchesStepAdded = true;
                    this.groupStageStep_py = cell_py;
                }

                if (stepImageName !== null) {
                    stepImage = new Phaser.Image(this.game, TrophyContainer.CELL_CLICKABLE_LIMIT_LEFT, cell_py, "texture_atlas_5", stepImageName);
                    this.add(stepImage);
                }

                matchCell = new MatchCell(this.game, this.tournamentData, i);
                matchCell.name = "" + i;
                matchCell.y = cell_py;
                // crear el rectangulo para detectar el click
                matchCell.boundingBox = new Phaser.Rectangle(TrophyContainer.CELL_CLICKABLE_LIMIT_LEFT, cell_py, 500, 90);

                this.add( matchCell );
                this.cells.push(matchCell);

                this.classificationStep_py = cell_py; // se quedara con el ultimo peldaño

                cell_py += 90;
            }

            this.lastCell_py = matchCell.y;
        }

        private addLabels(): void {

            let gameText = GameVars.gameText;

            let finalLabel = new Phaser.Text(this.game, 36, this.finalStep_py + 6, " " + gameText.FINAL + " " , {font: "76px whoopass", fill: "#DAE9E9"});
            finalLabel.setShadow(3, 3, "rgba(0,0,0,1)", 0);
            finalLabel.scale.y = GameVars.scaleY;
            this.addAt(finalLabel, 0);

            let semifinalLabel = new Phaser.Text(this.game, 90, this.semiStep_py + 10,  " " + gameText.SEMI + " " , {font: "66px whoopass", fill: "#DAE9E9"});
            semifinalLabel.setShadow(3, 3, "rgba(0,0,0,1)", 0);
            semifinalLabel.scale.y = GameVars.scaleY;
            this.addAt(semifinalLabel, 0);

            if (this.quarterStep_py !== 0) {
                let quarterLabel = new Phaser.Text(this.game, 52, this.quarterStep_py + 14,  " " + gameText.QUARTER + " " , {font: "45px whoopass", fill: "#DAE9E9"});
                quarterLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
                quarterLabel.scale.y = GameVars.scaleY;
                this.addAt( quarterLabel, 0);
            }

            if (this.roundOf16Step_py !== 0) {
                let roundOf16Label = new Phaser.Text(this.game, 26, this.roundOf16Step_py + 14,  " " + gameText.ROUND_OF_16 + " " , {font: "38px whoopass", fill: "#DAE9E9"});
                roundOf16Label.setShadow(2, 2, "rgba(0,0,0,1)", 0);
                roundOf16Label.scale.y = GameVars.scaleY;
                this.addAt( roundOf16Label, 0);
            }

            const groupStageLabel = new Phaser.Text(this.game, 25, this.groupStageStep_py + 16,  " " + gameText.GROUP_STAGE + " ", {font: "34px whoopass", fill: "#DAE9E9"});
            groupStageLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
            groupStageLabel.scale.y = GameVars.scaleY;
            this.addAt( groupStageLabel , 0);

            const clasLabel = new Phaser.Text(this.game, 56, this.classificationStep_py - 180, " " + gameText.CLAS + " ", {font: "76px whoopass", fill: "#DAE9E9"});
            clasLabel.setShadow(2, 2, "rgba(0,0,0,1)", 0);
            clasLabel.scale.y = GameVars.scaleY;
            this.addAt(clasLabel , 0);

            const sificLabel = new Phaser.Text(this.game, 80, this.classificationStep_py - 100,  " " + gameText.SIFIC + " ", {font: "76px whoopass", fill: "#DAE9E9"});
            sificLabel.setShadow(3, 3, "rgba(0,0,0,1)", 0);
            sificLabel.scale.y = GameVars.scaleY;
            this.addAt(sificLabel , 0);

            const ationLabel = new Phaser.Text(this.game,  30, this.classificationStep_py - 20,  " " + gameText.ATION + " ", {font: "76px whoopass", fill: "#DAE9E9"});
            ationLabel.setShadow(3, 3, "rgba(0,0,0,1)", 0);
            ationLabel.scale.y = GameVars.scaleY;
            this.addAt(ationLabel , 0);
        }

        private addClosingStripe(): void {

            this.stripeContainer = new Phaser.Group(this.game);
            this.stripeContainer.y =  this.lastCell_py + 120;
            this.stripeContainer.scale.y = GameVars.scaleY;
            this.add(this.stripeContainer);

            const blackGradientRectangle = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("dark_gradient"));
            blackGradientRectangle.scale.setTo(58 , 1.7);
            this.stripeContainer.add( blackGradientRectangle );

            const trophyImage = new Phaser.Image(this.game, 25, 30, "texture_atlas_2",  this.tournamentData.trophyImageName );
            trophyImage.anchor.set(0, .5);
            this.stripeContainer.add(trophyImage);

            const trophyLabel = new Phaser.Text(this.game, 145, this.tournamentData.titleLabel_py, " " + this.tournamentData.name + " ", {font: this.tournamentData.titleLabelFontSize + "px whoopass", fill: "#DAE9E9"});
            this.stripeContainer.add( trophyLabel);

            this.containerHeight = this.stripeContainer.y  + 138;
        }

        private addClosingStripeChangeTeamButton(): void {

            const changeTeamButton = new Phaser.Button(this.game, 638, 4, "texture_atlas_5", this.onClickChangeTeam, this, 1, 0, 1);
            changeTeamButton.setFrames("cambio_equipo_on", "cambio_equipo_off", "cambio_equipo_on");
            this.stripeContainer.add(changeTeamButton);
        }

        private addCursor(): void {

            const matchesData = this.tournamentData.matchesData;

            let i = matchesData.length;

            while (i--) {
                if (matchesData[i].locked) {
                    break;
                }
            }

            i = i === -1 ? 0 : i + 1;

            this.unlockedMatches = matchesData.length - i;


            // pillar la coordenada y de la boundingbox del array de celdas
            const cursor_py = this.cells[i].boundingBox.y - 20;

            this.teamCursor = new TeamCursor(this.game, this.tournamentData, cursor_py );
            this.add( this.teamCursor );
        }

        private addSelectTeamButton(): void {

            this.selectTeamButton = new Phaser.Button(this.game, 640, this.lastCell_py + 45 , "texture_atlas_5", this.onClickChangeTeam, this);
            this.selectTeamButton.anchor.set(.5);
            this.selectTeamButton.setFrames("select_team_button_on", "select_team_button_off", "select_team_button_on");
            this.add(this.selectTeamButton);

            const pulseTween = this.game.add.tween(this.selectTeamButton.scale);
            pulseTween.to ({x: 1.15, y: .9 * GameVars.scaleY}, 300,  Phaser.Easing.Linear.None);
            pulseTween.delay (50);
            pulseTween.to ({x: .9, y: 1.15 * GameVars.scaleY}, 700,  Phaser.Easing.Elastic.Out);
            pulseTween.loop();
            pulseTween.start();
        }

        private onClickChangeTeam(): void {

            GameManager.onClickChangeTeamButton(this.tournamentData.name);
        }
    }
